import { twMerge } from 'tailwind-merge';
import { Link } from 'react-router-dom';
import { Flash } from '@acast-tech/decibel';

export interface InfoBoxProps {
  intent?: 'primary' | 'secondary';
  title?: string;
  children: React.ReactNode;
  link?: {
    to: string;
    text: string;
  };
}

/**
 * This component is used to display an info box with a title, children, and a link.
 * Primarily built for the campaign types modal.
 * @param intent - The intent of the info box. Default is primary.
 * @param title - The title of the info box.
 * @param children - The children of the info box.
 * @param link - The link of the info box.
 * @returns The info box component.
 */
export const InfoBox = ({ intent = 'primary', title, children, link }: InfoBoxProps) => {
  return (
    <Flash intent={intent}>
      {title && <h3>{title}</h3>}
      {children}
      {link && (
        <Link
          to={link.to}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${link.text} (opens in new tab)`}
          className={twMerge(
            'hover:underline font-medium',
            intent === 'primary' ? `text-darkPurple` : 'text-textDarkGrey'
          )}
        >
          {link.text}
        </Link>
      )}
    </Flash>
  );
};
